import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgUitgangen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M20 10H6v24h14z"
    />
    <path
      fill="#60D15D"
      d="M28.97 20.6a5.03 5.03 0 1 0 0-10.06 5.03 5.03 0 0 0 0 10.06"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M29 20.63a5 5 0 0 1 5 5V34H23.94v-8.35A5 5 0 0 1 29 20.63"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M18.23 25.37h7.54v1h-7.54z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M16.56 23.99v1.57L13 22l3.56-3.56v1.57H22v3.98z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M16 6h-6v2h6z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgUitgangen);

export default ForwardRef;
